module.exports = __webpack_public_path__ + "76785e074b97fa59a60f8767cd23124a.png";